import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {FormFieldOption} from './form-field-option.model';

export const loadFormFieldOptions = createAction(
  '[FormFieldOption/API] Load FormFieldOptions',
  props<{ formFieldOptions: FormFieldOption[] }>()
);

export const addFormFieldOption = createAction(
  '[FormFieldOption/API] Add FormFieldOption',
  props<{ formFieldOption: FormFieldOption }>()
);

export const upsertFormFieldOption = createAction(
  '[FormFieldOption/API] Upsert FormFieldOption',
  props<{ formFieldOption: FormFieldOption }>()
);

export const addFormFieldOptions = createAction(
  '[FormFieldOption/API] Add FormFieldOptions',
  props<{ formFieldOptions: FormFieldOption[] }>()
);

export const upsertFormFieldOptions = createAction(
  '[FormFieldOption/API] Upsert FormFieldOptions',
  props<{ formFieldOptions: FormFieldOption[] }>()
);

export const updateFormFieldOption = createAction(
  '[FormFieldOption/API] Update FormFieldOption',
  props<{ formFieldOption: Update<FormFieldOption> }>()
);

export const updateFormFieldOptions = createAction(
  '[FormFieldOption/API] Update FormFieldOptions',
  props<{ formFieldOptions: Update<FormFieldOption>[] }>()
);

export const deleteFormFieldOption = createAction(
  '[FormFieldOption/API] Delete FormFieldOption',
  props<{ id: string }>()
);

export const deleteFormFieldOptions = createAction(
  '[FormFieldOption/API] Delete FormFieldOptions',
  props<{ ids: string[] }>()
);

export const clearFormFieldOptions = createAction(
  '[FormFieldOption/API] Clear FormFieldOptions'
);

//  CUSTOM
export const citizenGetFormFieldOptions = createAction(
  '[FormFieldOption/API] citizen get FormFieldOptions',
  props<{ fieldUniqueId: string }>()
);
